import React from "react";
import { Modal, Divider } from "antd";
import { ReviewARSubmissionInputValues } from "components/ReviewARSubmissionInput";

const SUMMARY_BOX_STYLE: React.CSSProperties = {
  background: "#fafafa",
  padding: "0.625rem 0.75rem",
  borderRadius: "0.25rem",
  marginBottom: "1rem",
  fontSize: "0.8125rem",
};

const SECTION_HEADER_STYLE: React.CSSProperties = {
  fontSize: "0.75rem",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.025rem",
  color: "rgba(0, 0, 0, 0.65)",
  marginBottom: "0.5rem",
};

const SECTION_WRAPPER_STYLE: React.CSSProperties = {
  marginBottom: "0.75rem",
};

const LIST_STYLE: React.CSSProperties = {
  margin: 0,
  paddingLeft: "1.125rem",
};

const INTERNAL_NOTE_TEXT_STYLE: React.CSSProperties = {
  fontSize: "0.8125rem",
  color: "rgba(0, 0, 0, 0.65)",
};

const DIVIDER_STYLE: React.CSSProperties = {
  margin: "0.75rem 0",
};

export interface ConfirmRejectionModalProps {
  visible: boolean;
  arLabel: string;
  review: ReviewARSubmissionInputValues;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmRejectionModal: React.FC<ConfirmRejectionModalProps> = ({
  visible,
  arLabel,
  review,
  onConfirm,
  onCancel,
}) => {
  const { reason, note } = review;
  const reasonList = Array.from(reason);
  const total = reasonList.length;

  return (
    <Modal
      title="Confirm rejection"
      visible={visible}
      onCancel={onCancel}
      onOk={onConfirm}
      okText="Confirm rejection"
      okButtonProps={{ type: "danger" }}
      cancelText="Back to edit"
      width={520}
    >
      <div style={SUMMARY_BOX_STYLE}>
        <strong>{arLabel}</strong> &mdash; {total} reason
        {total === 1 ? "" : "s"} selected
      </div>

      {total > 0 && (
        <div style={SECTION_WRAPPER_STYLE}>
          <div style={SECTION_HEADER_STYLE}>Reasons</div>
          <ul style={LIST_STYLE}>
            {reasonList.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      )}

      {note && (
        <>
          <Divider style={DIVIDER_STYLE} />
          <div style={SECTION_WRAPPER_STYLE}>
            <div style={SECTION_HEADER_STYLE}>Internal note (admin-only)</div>
            <div style={INTERNAL_NOTE_TEXT_STYLE}>{note}</div>
          </div>
        </>
      )}
    </Modal>
  );
};
